<template>
<sui-segment>


<DataTable :key="updateTable"
            uri="products"
            searchable
            deleteable
            showBtn
            long
            create
            :options="tableOptions"
            v-on:clickCreate="callbackClickCreate"
            v-on:clickEdit="callbackClickEdit"
            v-on:clickRow="callbackClickRow"
            v-on:clickRemove="callbackClickRemove" />



<v-dialog persistent v-model="showModal" width="900">

        <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                {{ $t("createProduct") }}
              </v-card-title>
              <br />
              <v-card-text>
                <v-text-field 
             :label="$t('name')"
             v-model="current.name"></v-text-field>
             <v-file-input
                 id="input"
                 v-model="file"
                 :label="$t('inputImage')"
                 truncate-length="15"
                 @change="handleLoadImage"
             ></v-file-input>
             <v-img class="prod-img" :src="current.base64image" v-if="current.base64image"></v-img> 
            <v-textarea :rules="rules.shortdescription" clearable counter rows="3" :label="$t('shortdescription')" v-model="current.shortdescription" ></v-textarea>
				<br>
				<v-textarea :rules="rules.description" clearable counter rows="15" :label="$t('description')" v-model="current.description" ></v-textarea>
				<br>
<!--             
             <v-text-field 
             :label="$t('price')"
             v-model="current.price"
             append-icon="mdi-currency-eur"></v-text-field> -->
             <v-select
                v-if="!allGroups"
                :items='groupDropdown'
                item-value="key"
                item-text="value"
                :label="$t('groups')"
				multiple
                v-model="current.groups"></v-select>
                <v-checkbox :label="$t('allGroups')" v-model="allGroups"></v-checkbox>
                <v-row>
                    <v-col cols=8></v-col>
                    <v-col cols=2>
                        <v-btn color="green" class="text--right" @click.prevent="handleSaveProduct">{{$t('save')}}</v-btn>
                    </v-col><v-col cols=2>
                        <v-btn color="red" class="text--right" @click.prevent="handleCloseModal">{{$t('cancel')}}</v-btn>
                    </v-col>
                </v-row>
              </v-card-text>
            </v-card>
    </v-dialog>

</sui-segment>
</template>
<script>


import ApiService from '@/services/ApiService.js'
import DataTable from '@/components/DataTable.vue'
export default {
    components: {
        DataTable
    },
    data() {
        return {
            products: {},
            file: null,
            showModal: false,
            showEditModal: false,
            current: {},
            updateTable: 0,
            allGroups: false,
            tableOptions: {
            columns: [
                {label: this.$t('image'), name: 'image', image:true, sortable:false },
                {label: this.$t("productID"), name: "id"},
                {label: this.$t('name'), name: 'name' },
                // {label: this.$t("price"), name: "price"}, 
                {label: this.$t('createdAt'), name: 'created_at', time:true },
                {label: this.$t('actions'), name: 'actions', sortable:false },
            ],
            search: '',
            start: 0,
            limit: 10,
            sortKey: 'id',
            sortAs: "asc"
            },
            noclick: false,
		    groupDropdown: [],
			rules: {
				shortdescription:[v => v.length <= 500 || this.$t('Max500Characters')],
				description:[v => v.length <= 10000 || this.$t('Max10000Characters')],
				},
        }
    },
    async created(){
    	  let res = await ApiService.getGroupDropdown();
        for(let [key, value] of Object.entries(res.data)){
			this.groupDropdown.push({key:key, value:value})
		}
    },
    methods: {
        callbackClickCreate(){
            this.current = {}
            this.file = null
            this.allGroups= false
            this.showModal = true
        },
        handleCloseModal(){
            this.current = {}
            this.file = null
            this.showModal = false
        },
        async callbackClickRemove(row){
            this.noclick = true
            let self = this
            this.$swal.fire({
                icon: "warning",
                title: this.$t("areYouSure"),
                text: this.$t("youCantRevert"),
                showCancelButton: false,
                showDenyButton: true,
                confirmButtonText: this.$t('yesDelete'),
                denyButtonText: this.$t("noKeep")
                }).then(async(result) => {
                    self.noclick = false
                if (result.isConfirmed) {
                    let res = await ApiService.deleteProduct(row.id);
                    if (res===false) {
                        this.updateTable++
                        this.$swal({
                            icon: "success",
                            title: this.$t("deleted"),
                            text: this.$t("deleteSuccess")
                        })
                    }
                }
            })
        },
        async callbackClickRow(row){
            if(!this.noclick) this.$router.push('/product/'+row.id)
        },
        async callbackClickEdit(row){
            this.$router.push('/product/'+row.id+ "?edit=true")
        },
        async handleLoadImage(){
            this.current.base64image =await this.getFile(this.file)
            this.$forceUpdate()
        },
        async handleSaveProduct(){
            // return console.log(this.file)

            let image = this.file != null ? await this.getFile(this.file) : null

            this.allGroups ? this.current.groups = "all" : ""
            var data = {
                name: this.current.name,
                description: this.current.description,
                shortdescription: this.current.shortdescription,
                // price: 0,
                image: image,
                groups: this.current.groups
            }
            let resp = await ApiService.postProduct(data)
            if(resp.status == 201){
                this.$swal( this.$t("yea"), this.$t("saved"), "success")
                this.showModal = false
                this.updateTable++
            }else{
                this.$swal( this.$t("error"), this.$t(resp.data.message), "error")
            }

        },
        async handleSaveEditProduct(){
            
            let image = this.file != null ? await this.getFile(this.file) : null

            image != null ? this.current.image = image : ""
            let resp = await ApiService.putProduct(this.current.id, this.current)
            if(resp.status == 200){
                this.$swal( this.$t("yea"), this.$t("saved"), "success")
                this.updateTable++
                this.showEditModal = false
            }

        },
        getFile(selectedFile){
            return new Promise(function(resolve,reject){
            var reader = new FileReader();
                reader.readAsDataURL(selectedFile);
                reader.onload = function () {
                    console.log("file gotten")

                    // var result = reader.result.split(";base64,")[1]
                    resolve(reader.result);
                };
                reader.onerror = function(error){
                    reject(error);
                }
            })
        },
        fileInput(){
                const fileInput = document.getElementById('input');
                const selectedFile = fileInput.files[0];
                console.log(selectedFile);   
                var reader = new FileReader();
                reader.readAsDataURL(selectedFile);
                reader.onload = function () {
                    console.log(reader.result);
                };
                reader.onerror = function (error) {
                    console.log('Error: ', error);
                };
        }
    }
}
</script>

<style>
.prod-img {
    height: 400px;
    width: 400px;
}
</style>